import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { usePostSiteGoogleReportOauthSaveMutation } from '../../app/api'
import { showAlert } from '../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../app/store/hooks/Redux'

export const LinkEmailPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [googleReportOauthSave] = usePostSiteGoogleReportOauthSaveMutation()

  useEffect(() => {
    const path = localStorage.getItem('last-path') || '/profile-settings'

    if (searchParams.has('code')) {
      googleReportOauthSave({ code: searchParams.get('code') as string })
        .unwrap()
        .then((response) => {
          if (response.success) {
            dispatch(
              showAlert({
                message: `The email ${response.data?.email} has been added successfully. Please navigate to PPC Compliance and submit your reports.`,
                type: 'success',
                timeout: 2000,
              }),
            )
          }
        })
        .catch(() => undefined)
        .finally(() => navigate(path))
    } else {
      navigate(path)
    }
  }, [searchParams])

  return null
}
